import classnames from 'classnames/bind'
import { Text, useApplicationContext, optInSMSText } from '@adc/ui-adc'
import styles from '../styles.scss'

const cx = classnames.bind(styles)

export const PRIVACY_STATEMENT = `By checking this box, ${optInSMSText?.consentMessage}`
const ContactInformationFooter = () => {
  const featureFlags: Record<string, unknown> =
    useApplicationContext().featureFlags

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const enableNewDesign =
    // @ts-ignore next
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    featureFlags['fe.resi.ab.testing.on.conversational.flow.step.order']?.GA
      ?.testVariant2 !== 'control_mvp'

  const privacyStatementText: JSX.Element | string = (
    <span>{PRIVACY_STATEMENT}</span>
  )

  return (
    <Text
      size='mini'
      className={cx(enableNewDesign ? 'privacy-statement' : '')}
    >
      {privacyStatementText}
    </Text>
  )
}

export default ContactInformationFooter
